import { createFileRoute, redirect } from "@tanstack/react-router";

// Monthly monitoring moved into credential settings; keep old links working.
export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/providers/monitoring/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/org/bu/$organizationBusinessUnitId/providers/credentials/settings",
      params,
      replace: true,
    });
  },
});
